export default __webpack_public_path__ + "static/media/nis_xl.fd0483f3.jpg";